import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './plugins/vuex'
import VueSession from 'vue-session'
import axios from 'axios'

import './assets/scss/main.scss'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSession)

axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
